<template>
  <div class="flex flex-col gap-3">
    <ChartContainer :config="model.config" class="h-[260px] w-full">
      <VisXYContainer :data="model.data" :margin="{ left: 8, right: 8 }">
        <VisLine
          v-if="kind === 'line'"
          :x="(d: XyDatumType) => d.index"
          :y="model.accessors"
          :color="model.colors"
          :line-width="2"
          :curve-type="CurveType.Linear"
        />
        <VisGroupedBar
          v-else
          :x="(d: XyDatumType) => d.index"
          :y="model.accessors"
          :color="model.colors"
          :rounded-corners="4"
          :group-padding="0.2"
          :bar-padding="0.1"
        />
        <VisAxis
          type="x"
          :tick-format="(i: number) => model.labels[i] ?? ''"
          :tick-values="model.tickValues"
          :grid-line="false"
          :tick-line="false"
          :domain-line="false"
        />
        <VisAxis type="y" :tick-format="formatNumber" :num-ticks="4" :tick-line="false" :domain-line="false" />
        <ChartTooltip />
        <ChartCrosshair :template="crosshair" color="var(--border)" />
      </VisXYContainer>
    </ChartContainer>
    <ul v-if="model.series.length > 1" class="flex flex-wrap gap-x-4 gap-y-1 text-sm">
      <li v-for="(name, index) in model.series" :key="name" class="flex items-center gap-2">
        <span class="inline-block size-2.5 rounded-[2px]" :style="{ background: model.colors[index] }" />
        {{ name }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { CurveType } from '@unovis/ts'
import { VisAxis, VisGroupedBar, VisLine, VisXYContainer } from '@unovis/vue'
import { computed } from 'vue'

import { ChartContainer, ChartCrosshair, ChartTooltip } from '@/components/ui/chart'
import type { DashboardChartType } from '@/features/admin/analytics/api/dashboard'
import {
  buildXyModel,
  formatNumber,
  type XyDatumType,
  xyTooltip,
} from '@/features/ui/pages/admin/dashboard/dashboard-content/chart-helpers'

const props = defineProps<{ chart: DashboardChartType; kind: 'line' | 'bar' }>()

const model = computed(() => buildXyModel(props.chart))
const crosshair = (d: XyDatumType) => xyTooltip(model.value, d)
</script>
